<template>
  <div class="container order-change-container">
    <div class="change-title">
      升舱改期
    </div>
    <div class="change-search">
      <div class="change-pass-header" v-for="(passenger, passIndex) in detail.travelers" :key="passIndex">
        <span class="h-strong"> <l8-icon class="l8-icon" type="icon-lvke"/>
 旅客{{ +passIndex + 1 }}</span>
        <span class="h-msg">
          <span>{{ passenger.fullName }}</span>
          <span>{{ passenger.certificateType | certificateType }}：{{ passenger.certificateNo | codeMask({offset: 4, length: 10}) }}</span>
          <span>联系电话：{{ passenger.mobile | codeMask }}</span>
        </span>
      </div>
      <div class="change-table-warp">
        <table class="order-default-table change-seg-table">
          <thead>
            <tr>
              <td>航班号</td>
              <td>行程</td>
              <td>起飞时间</td>
              <td>到达时间</td>
              <td>舱位</td>
              <td>新出行日期</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="( seg, segIndex ) in detail.flightSegments" :key="segIndex">
              <td>{{ seg.airlineName}} {{ seg.flightNo }}</td>
              <td>{{ seg.departureAirPortName }} - {{ seg.arrivalAirPortName }}</td>
              <td>{{ seg.departureDate }} {{ seg.departureTime }}</td>
              <td>{{ seg.arrivalDate }} {{ seg.arrivalTime }}</td>
              <td>{{ seg.cabinCode }}/{{ seg.cabinRebate | discount }}</td>
              <td>
                <a-date-picker
                  placeholder="请选择改期日期"
                  :showToday="false"
                  :defaultPickerValue="moment(seg.departureDate)"
                  :disabledDate="changeDisabledDate(seg.departureDate, segIndex)"
                  @change="onDateChange($event, seg)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="order-action-row">
      <a-button type="primary" @click="changeQueryHandler" :loading="changeQueryLoading">查询航班</a-button>
    </div>
    <div class="search-result" v-if="newSegments.length">
      <div
        class="new-seg"
        v-for="(seg, segIndex) in newSegments"
        :key="segIndex"
      >
        <!-- NOTE: ALL - 往返程补充提示及按钮限制 -->
        <template v-if="checkSegmentEmpty(1)">
           <div class="new-seg-header order-primary-header">
            <l8-icon class="l8-icon" type="icon-feiji1"/>
            <span class="header-label">{{ selectedSegs?.[0].departureName }}-{{ selectedSegs?.[0].arrivalName }}</span>
          </div>
          <p class="new-seg-empty-tips">尊敬的旅客，该日期的航班暂无自助改期可选舱位。您可选择其他日期的航班，或拨打{{ appInfo.hotline }}联系客服人员为您办理人工改期。</p>
        </template>
        <div class="new-seg-header order-primary-header">
          <l8-icon class="l8-icon" type="icon-feiji1"/>
          <span class="header-label">{{ seg.segments[0].departureName }}-{{ seg.segments[0].arrivalName }}</span>
        </div>
        <SegItineraries
          :itineraries="seg.itinerarys"
          :detail="detail"
          :ifInternational="ifInternational"
          @select="segItiSelectHandler($event, seg)"
        >
        </SegItineraries>
        <template v-if="checkSegmentEmpty(0)">
           <div class="new-seg-header order-primary-header">
            <l8-icon class="l8-icon" type="icon-feiji1"/>
            <span class="header-label">{{ selectedSegs?.[1].departureName }}-{{ selectedSegs?.[1].arrivalName }}</span>
          </div>
          <p class="new-seg-empty-tips">尊敬的旅客，该日期的航班暂无自助改期可选舱位。您可选择其他日期的航班，或拨打{{ appInfo.hotline }}联系客服人员为您办理人工改期。</p>
        </template>
      </div>
      <div class="search-agree">
        <a-checkbox :checked="searchAgree" @change="onSearchAgree"></a-checkbox>
        <span>我已阅读并接受
          <template v-for="(item, index) in agreeListWithFilter">
            <router-link :to="item.url" :key="index" target="_blank">{{ item.name }}{{ index === (agreeListWithFilter?.length - 1) ? '' : '，'}}</router-link>
          </template>
        </span>
      </div>
      <div class="order-action-row">
        <a-button v-if="changeSubmitVisible" :loading="changeCreateLoading" type="primary" @click="submitChangeHandler">确认提交</a-button>
      </div>
    </div>
    <div class="order-extra-tips" v-if="changeSearchTips" v-html="changeSearchTips"></div>
  </div>
</template>

<script>
import '@/components/l8-icon'
import '@/assets/css/l8-order-common.less'
import { get, each, filter, countBy, find, assign } from 'lodash'
import queryString from 'query-string'
import moment from 'moment'
import { isYoungOrOld, filterRegion } from '@/assets/js/util'
import SegItineraries from './modules/SegItineraries'
import { paxSegmentNew, queryChangeNewV2, chooseValidate, createNewV2 } from '@/apis/change'
import { certificateType } from '@/filters/order'
import { userTypeMap } from '@/dicts/member'
import yoProductConfig from '@/data/yoProductConfig'
import getAppInfo from '@/utils/from'
import './index'

const mainSettings = window.__MICRO_ROOT__ ?? {}

// const chengduAirport = ['CTU', 'TFU']
// const qingdaoAirport = ['TAO']
// const chengduChangeDate = moment('2021-06-29')

export default {
  data () {
    return {
      orderId: '',
      ids: [],
      selectedSegs: [],
      newSegments: [],
      detail: {},
      selectedNewSegProd: [],
      searchAgree: false,
      changeQueryLoading: false,
      changeCreateLoading: false,
      agreeList: [],
      airline: mainSettings.airline,
      userId: '',
      appInfo: getAppInfo(),
      criteria: {},
      changeSearchTips: '',
      ifInternational: false
    }
  },
  created () {
    this.getCmsData()
    let query = queryString.parse(location.search)

    this.orderId = query.orderId
    this.ids = query?.Ids?.split(';')
    this.ifInternational = query.ifInternational === 'true'

    const userInfo = mainSettings.user?.get()
    if (userInfo) {
      if (userTypeMap[userInfo.userType] === 'CARRIER') {
        this.userId = query.outUserId
      }
    }

    this.fetchPaxSeg()
  },
  computed: {
    changeSubmitVisible () {
      const { selectedSegs = [], newSegments = [] } = this
      return selectedSegs.length === newSegments.length
    },
    isSelfAirline () {
      const { newSegments, airline } = this
      return get(newSegments[0], 'itinerarys[0].orgDsts[0].airlineCode') ? newSegments[0].itinerarys[0].orgDsts[0].airlineCode === airline : false
    },
    agreeListWithFilter () {
      // type:  all | self | other
      // 航班类型
      const { isSelfAirline, agreeList, ifInternational } = this
      const agreeListWithFilter = agreeList?.filter(item => {
        const currentType = item.type === 'all' ||
      (item.type === 'self' && isSelfAirline) ||
      (item.type === 'other' && !isSelfAirline)
      // 航班地区
        const currentRegion = filterRegion(item, ifInternational)
        return currentType && currentRegion
      }) ?? []
      return agreeListWithFilter
    }
  },
  methods: {
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          const { list } = res?.newOrderChangeAgree
          const { ifInternational } = this
          this.agreeList = list || []
          // this.changeSearchTips = res?.changeSearchTips?.content ?? ''
          this.changeSearchTips = get(res, !ifInternational ? 'changeSearchTips.notice' : 'changeSearchTips.internationalNotice') ?? get(res, 'changeSearchTips.content')
        })
      } catch (err) {}
    },
    onSearchAgree (e) {
      this.searchAgree = e.target.checked
    },
    changeDisabledDate (depDate, segIndex) {
      return (current) => {
        return current && current < moment().startOf('day')
      }
    },
    onDateChange: function (moment, seg) {
      let dup = null

      each(this.selectedSegs, (_seg, segIndex) => {
        if (_seg.id === seg.id) {
          dup = segIndex
        }
      })

      const updateSeg = {
        moment,
        id: seg.id,
        orderItemServiceDetailIds: seg.orderItemServiceDetailIds,
        departureName: seg.departureName,
        departureCode: seg.departureCode,
        arrivalName: seg.arrivalName,
        arrivalCode: seg.arrivalCode,
        cabinCode: seg.cabinCode,
        ticketNo: seg.ticketNo,
        ticketNoList: seg.ticketNoList
      }

      if (dup !== null) {
        this.selectedSegs.splice(dup, 1, updateSeg)
      } else {
        if (!moment) {
          this.selectedSegs.splice(dup, 1)
        } else {
          this.selectedSegs.push(updateSeg)
        }
      }
    },
    fetchPaxSeg: async function () {
      const { airline, orderId, ids } = this

      try {
        const { offers, criteria } = await paxSegmentNew({
          alineCode: airline,
          orderId,
          orderItemServiceDetailIds: ids
        })
        this.criteria = criteria
        if (offers && !offers.length) {
          this.$message.error('该日期没有可改升航班，请更改查询日期')
        } else {
          this.updateChangeDetail(offers && offers[0].detail)
        }
      } catch (err) {
        this.$message.error(err.message || '改期航班查询失败，请稍后再试')
      }
    },
    updateChangeDetail (detail) {
      this.detail = detail
    },
    validChangeSeg () {
      const { selectedSegs } = this
      if (!selectedSegs.length) {
        this.$message.error('请选择改期时间')
        return
      }

      let count = countBy(selectedSegs, (item) => {
        return item.moment === null ? 'null' : 'able'
      })

      if (count.able < this.detail.flightSegments.length) {
        this.$message.error('选择所有航段的改期时间')
        return
      }

      // TODO: 祥鹏专属逻辑
      // 成都机场转场
      // let isTFU = false
      // const chengduSeg = find(selectedSegs, item => {
      //   const didx = chengduAirport.indexOf(item.departureCode)
      //   const aidx = chengduAirport.indexOf(item.arrivalCode)
      //   if (didx > -1 || aidx > -1) {
      //     const idx = didx > -1 ? didx : aidx
      //     isTFU = !!idx
      //     return idx ? item.moment.isBefore(chengduChangeDate.add(1, 'd')) : item.moment.isAfter(chengduChangeDate)
      //   }
      //   return false
      // })
      // 青岛机场转场
      // const qingdaoSeg = find(selectedSegs, item => {
      //   const didx = qingdaoAirport.indexOf(item.departureCode)
      //   if (didx > -1) {
      //     return true
      //   }
      //   return false
      // })

      // if (chengduSeg) {
      //   this.$warning({
      //     title: '温馨提示',
      //     content: isTFU ? '尊敬的旅客，6月30日祥鹏航空成都航班转场至天府机场，您选择的日期航班出发地/目的地调整至成都双流机场，无法进行改期，请您重新出票，将原票提交为非自愿退票，并备注上新客票号，我们将会收取改期费后尽快退还差价，谢谢！' : '尊敬的旅客，6月30日祥鹏航空成都航班转场至天府机场，您选择的日期航班出发地/目的地已调整至成都天府机场，无法进行改期，请您重新出票，将原票提交为非自愿退票，并备注上新客票号，我们将会收取改期费后尽快退还差价，谢谢！'
      //   })
      //   return
      // }

      // if (qingdaoSeg) {
      //   this.$warning({
      //     title: '温馨提示',
      //     content: '尊敬的旅客：自2021年8月12日零点起，青岛进出港国内航班全部转场到青岛胶东国际机场运营，请您在购票前仔细确认， 感谢您的理解与配合。'
      //   })
      // }
      this.fetchNewSeg()
    },
    async fetchNewSeg () {
      this.changeQueryLoading = true
      this.newSegments = []
      this.selectedNewSegProd = []

      const { airline, criteria, userId, ifInternational } = this
      let params = {
        alineCode: airline,
        orderId: criteria.orderId,
        orderNo: criteria.orderNo,
        originDestinations: [],
        tripType: 'OW'
      }

      each(this.selectedSegs, (seg) => {
        // let ticketNoList = []
        // ticketNoList.push(getAppInfo()?.ticketCode + '-' + seg.ticketNo)
        // ticketNoList = uniq(ticketNoList)
        params.originDestinations.push({
          depCode: seg.departureCode,
          arrCode: seg.arrivalCode,
          flightDate: seg.moment.format('YYYYMMDD'),
          orderItemServiceDetailIds: seg.orderItemServiceDetailIds,
          ticketNoList: seg.ticketNoList
        })
      })

      if (this.userId) {
        params.outUserId = userId
      }

      if (ifInternational) {
        params.internationalFlag = ifInternational
      }
      // const { criteria, userId } = this
      // const params = {
      //   orderId: criteria.orderId,
      //   orderNo: criteria.orderNo,
      //   type: 'OW',
      //   originDestinations: [],
      //   ticketList: []
      // }

      // if (this.userId) {
      //   params.outUserId = userId
      // }

      // each(this.selectedSegs, (seg) => {
      //   params.originDestinations.push({
      //     depCode: seg.departureCode,
      //     arrCode: seg.arrivalCode,
      //     orgDepCode: seg.departureCode,
      //     orgArrCode: seg.arrivalCode,
      //     depTime: seg.moment.format('YYYY-MM-DD')
      //   })

      //   params.ticketList.push({
      //     ticketNo: getAppInfo()?.ticketCode + '-' + seg.ticketNo
      //   })
      // })

      try {
        const res = await queryChangeNewV2(params)

        this.changeQueryLoading = false

        if (res.offers.length) {
          each(res.offers, (offer, offerIndex) => {
            this.updateChangeItineraries(offer.detail, res.criteria.originDestinations[offerIndex])
          })
        } else {
          this.$message.error(`抱歉，暂无可改升航班，请查询其他日期`)
        }
      } catch (err) {
        this.changeQueryLoading = false
        this.$message.error(err.message || '改期航班查询失败，请稍后再试')
      }
    },
    updateChangeItineraries (itineraries, criteria) {
      this.newSegments.push(assign(itineraries, { criteria }))
    },
    changeQueryHandler () {
      this.changeCreateLoading = false
      this.validChangeSeg()
    },
    segItiSelectHandler (e, seg) {
      const { product, orgdst } = e
      let segProd = assign(product, { criteria: seg.criteria, segment: seg.segments[0] }, { orgdst })
      let dup = null

      each(this.selectedNewSegProd, (_segProd, segProdIndex) => {
        if (_segProd.criteria.orderItemServiceDetailIds[0] === segProd.criteria.orderItemServiceDetailIds[0]) {
          dup = segProdIndex
        }
      })

      if (dup !== null) {
        this.selectedNewSegProd.splice(dup, 1, segProd)
      } else {
        this.selectedNewSegProd.push(segProd)
      }
    },
    // 预订校验（临期）
    async chooseValidate () {
      const { selectedNewSegProd, airline } = this
      this.changeCreateLoading = true
      const flights = selectedNewSegProd.map(product => {
        const orgdst = product.orgdst
        return {
          depCode: orgdst.departureCode,
          depTime: `${orgdst.departureDate} ${orgdst.departureTime}`,
          arrCode: orgdst.arrivalCode,
          flightNo: orgdst.flightNo
        }
      })

      try {
        const { code, message } = await chooseValidate({
          airline,
          type: 'CHANGE_QUERY_CHECK',
          flights
        })

        if (code === '200') {
          this.submit()
        } else if (code === '100010018') {
          // 二次确认
          this.$confirm({
            title: '温馨提示',
            content: message,
            okText: '同意并预订',
            cancelText: '重新选择',
            onOk: () => {
              this.submit()
            },
            onCancel: () => {
              this.changeCreateLoading = false
            }
          })
        } else {
          this.changeCreateLoading = false
          this.$error({
            title: '温馨提示',
            content: message,
            okText: '重新选择'
          })
        }
      } catch (err) {
        this.changeCreateLoading = false
        this.$message.error(err.message || '网络异常，请稍后再试！')
      }
    },
    async submitChangeHandler () {
      if (!this.searchAgree) {
        return this.$message.warn('请先阅读并同意改期协议')
      }

      if (this.selectedNewSegProd.length < this.selectedSegs.length) {
        return this.$message.warn('请选择各改期航段产品')
      }

      await this.chooseValidate()
    },
    submit () {
      const special = filter(this.selectedSegs, (seg) => {
        return ['W', 'I', 'D'].indexOf(seg.cabinCode) > -1
      })

      if (!special.length) {
        this.submitChange()
        return
      }

      let cabinChange = {
        check: false,
        cabin: null
      }

      // Q, I, D舱改期提示
      each(this.selectedNewSegProd, (prod, prodIdx) => {
        const orgSeg = find(this.selectedSegs, { departureCode: prod.segment.departureCode })
        if (['W', 'I', 'D'].indexOf(orgSeg.cabinCode) > -1 && orgSeg.cabinCode !== prod.services[0].cabinCode) {
          cabinChange.check = true
          cabinChange.cabin = orgSeg.cabinCode
        }
      })

      if (cabinChange.check) {
        this.$confirm({
          title: '温馨提示',
          width: 600,
          content: `如将${cabinChange.cabin}舱变更至其他舱位，将不再享受原${cabinChange.cabin}舱的相关服务权益，具体服务内容以变更后的舱位为准。`,
          okText: '确定',
          onOk: () => {
            this.submitChange()
          },
          cancelText: '取消',
          onCancel: () => {

          }
        })
      } else {
        this.submitChange()
      }
    },
    async submitChange () {
      const { airline, orderId, ifInternational } = this
      let params = {
        alineCode: airline,
        orderId,
        orderItemServiceDetailIds: [],
        offerItemIds: []
      }
      if (ifInternational) {
        params.internationalFlag = ifInternational
      }
      // 校验青老年产品的对乘机人证件和年龄的判断
      let flag = true
      const { travelers } = this.detail
      const { selectedNewSegProd } = this
      const yoProduct = find(yoProductConfig, { airline })
      if (yoProduct) {
        const { youngMin, youngMax, oldMin } = yoProduct
        selectedNewSegProd.forEach(seg => {
          seg.services.forEach(service => {
            if (service.productCode === yoProduct.productCode) {
              travelers.forEach(traveler => {
                if (traveler.type === 'ADULT') {
                  if (traveler.certificateType !== 'NI') {
                    this.$message.error('旅客您好，预订青老年特惠产品，成人旅客须使用身份证。')
                    flag = false
                    return false
                  }
                  if (!isYoungOrOld(traveler.certificateNo, seg.orgdst.departureDate, { youngMin, youngMax, oldMin })) {
                    this.$message.error(`旅客您好，预订青老年特惠产品，成人旅客年龄须为${youngMin}周岁(含)至${youngMax}周岁(含)或${oldMin}周岁(含)以上。`)
                    flag = false
                    return false
                  }
                }
              })
            }
          })
        })
      }
      if (!flag) {
        this.changeCreateLoading = false
        return false
      }

      each(this.selectedNewSegProd, (segProd) => {
        // params.orderItemServiceDetailIds = params.orderItemServiceDetailIds.concat(segProd.criteria.orderItemServiceDetailIds)

        params.offerItemIds.push({
          offerItemId: segProd.offerItemId,
          orderItemServiceDetailIds: segProd.criteria.orderItemServiceDetailIds,
          ticketNoList: segProd.criteria.ticketNoList,
          // TODO: 改升默认传第一种价格类的价格，待需求更新完善
          code: segProd.services[0].fareDetails[0].fares[0].code,
          offerServices: [
            {
              offerServiceId: segProd.services[0].serviceId
            }
          ]
        })
      })

      try {
        const res = await createNewV2(params)

        this.changeCreateLoading = false
        this.$message.success('改期申请成功，正在跳转支付...', () => {
          const query = {
            orderId: this.orderId,
            changeId: res.changeId,
            ifInternational: this.ifInternational
          }

          if (this.userId) {
            query.outUserId = this.userId
          }

          this.$router.replace({ path: '/order/change/v2/detail', query })
        })
      } catch (err) {
        this.changeCreateLoading = false
        this.$message.error(err.message || '改期航班查询失败，请稍后再试')
      }
    },
    // NOTE: 根据 segIndex 判断往返某一行程是否为空
    checkSegmentEmpty (segIndex) {
      const { selectedSegs, newSegments } = this
      if (newSegments?.length === selectedSegs?.length) {
        return false
      }
      return selectedSegs?.[segIndex]?.departureCode === newSegments?.[0]?.segments?.[0]?.departureCode
    }
  },
  components: {
    SegItineraries
  },
  filters: {
    certificateType,
    discount (val) {
      const value = parseFloat(val)

      if (isNaN(value)) {
        return '-'
      }

      return value >= 1 ? '全价' : `${(value * 10).toFixed(1)}折`
    }
  }
}
</script>

<style lang="less">
  .keep-all() {
    word-break: keep-all;
    white-space: nowrap;
  }

  .change-title {
    font-size: 26px;
    font-weight: bold;
    margin: 54px 0;
  }

  .change-pass-header {
    padding: 10px 0;

    .h-strong {
      font-size: 22px;
      font-weight: bold;
      .keep-all;
    }

    .h-msg {
      font-size: 14px;
      margin-left: 30px;
      .keep-all;
    }

    .h-msg span {
      margin: 0 10px;
    }
  }

  .search-result {
    margin-top: 60px;
  }

  .new-seg {
    font-size: 12px;
    +  .new-seg {
      margin-top: 30px;
    }

    .new-seg-header {
      padding: 15px 0;
    }

    .new-seg-empty-tips {
      font-size: 14px;
      margin: 10px 0;
    }

  }

  .change-seg-table {
    tbody {
      tr {
        td {
          &:last-child {
            text-align: right;
          }
        }
      }
    }

    .ant-calendar-picker-input.ant-input {
      height: 50px;
    }
  }

  table.seg-info-table {
    text-align: center;
    width: 100%;
    border: 1px solid #dcdcdc;

    td {
      height: 98px;
      vertical-align: middle;
      word-break: keep-all;
      white-space: nowrap;
    }

  }

  .seg-logo-col {
    width: 68px;
  }

  .seg-logo {
    display: inline-block;
    width: 40px;
    height: 62px;
    background: url(../../assets/img/l8_logo.png);
    background-repeat: no-repeat;
  }

  .seg-date-col {
    width: 70px;
  }

  .seg-time {
    color: #111;
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 14px;
    line-height: 1em;
  }

  .seg-airport {
    color: #111;
    font-weight: bold;
  }

  .seg-flight-type {
    width: 148px;
    text-align: center;
    padding: 0 14px;
  }

  .seg-dur {
    position: relative;
    background: #fff;

    .dur-time {
      background: #fff;
      display: inline-block;
      padding: 0 3px;
      position: relative;
      z-index: 5;
    }

    &:after {
      content: '';
      display: block;
      width: 100%;
      border-bottom: 1px solid #bfbfbf;
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 1;
    }
  }

  .seg-day {
    width: 286px;
  }

  .seg-no {
    width: 182px;
  }

  .seg-toggle {
    text-align: right;
    padding: 0 38px;
    color: @primary-color;

    .seg-toggle-btn {
      cursor: pointer;
    }

    .l8-icon-outer {
      display: inline-block;
      width: 22px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      margin-right: 5px;
      border: 1px solid @primary-color;
      border-radius: 20px;
    }

    .l8-icon {
      font-size: 12px;
    }
  }

  .search-agree {
    padding: 10px 0;
    font-size: 14px;
    margin-top: 20px;
  }

  .l8-order-popover {

    .ant-popover-inner {
      background-color: #fff;
      background-clip: padding-box;
      border-radius: 0;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
    }

    .ant-popover-title {
      min-width: 177px;
      min-height: 32px;
      line-height: 32px;
      margin: 0;
      padding: 0 16px;
      font-weight: bold;
      color: #9d8d6e;
      text-align: center;
      font-size: 12px;
      border-bottom: 1px solid #dfdfdf;
    }
    .ant-popover-inner-content {
      padding: 0;
      color: #808080;
      font-size: 12px;
    }

  }

  @media only screen and (max-width: 768px) {
    .change-pass-header {
      overflow-x: scroll;
    }

    .change-seg-table {
      .ant-calendar-picker {
        width: 200px;
      }
    }

    .new-seg-list {
      overflow-x: scroll;
    }

    .change-table-warp {
      overflow-x: scroll;
    }

    .seg-change-info {
      overflow-x: scroll;
    }

    .seg-products {
      overflow-x: scroll;
    }

    table.seg-info-table td {
      word-break: keep-all;
      white-space: nowrap;
      padding: 0 10px;
    }
  }

</style>
